import OBase from './OBase';
import * as Geometry from '../geometry';

export default class ListItem extends OBase {
  update () {
    let lInputTree = this.getObjectInput('List');
    let iInputTree = this.getFloatInput('Index');
    let wInputTree = this.getBoolInput('Wrap');

    let output = this.getGenericObjectOutput('Item');

    const dataTrees = [];
    let outDataTrees = [];
    dataTrees.push(lInputTree, iInputTree, wInputTree)

    Geometry.makeMultipleBranches(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();

    lInputTree = outDataTrees[0];
    iInputTree = outDataTrees[1];
    wInputTree = outDataTrees[2];

    for(let i=0; i < outDataTrees[0].branches.length; i++){
      let path = lInputTree.paths[i];
      let list = lInputTree.branches[i];
      let indices = iInputTree.branches[Math.min(i, iInputTree.branches.length - 1)];
      let wrap = wInputTree.branches[Math.min(i, wInputTree.branches.length - 1)];

      for (let j = 0, m = indices.length; j < m; j++) {
        let idx = Math.floor(indices[j]);
        let w = wrap[Math.min(j, wrap.length - 1)];
        if (w === undefined) {
          w = false;
        }

        let item = null;
        if (w) {
          item = list[idx % list.length];
        } else {
          item = list[idx];
        }

        let outPath = path.clone();
        outTree.add(item, outPath);
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ListItem.js